import { useI18n } from 'contexts/i18n';
import { Styled } from './';
import { ProductDisclaimerAPACProps } from './';

export const ProductDisclaimerAPAC: React.FC<ProductDisclaimerAPACProps> = ({
  product,
  countryCode,
  i18n,
}) => {
  const stickableSKUs = [
    '213821',
    '213822',
    '213823',
    '213824',
    '213825',
    '213826',
    '213827',
    '213828',
    '213829',
    '213830',
    '213831',
  ];

  return (
    <ul>
      <Styled.DisclaimerListItem>
        {
          i18n[
            'Please note that the product labels may vary from those depicted here.'
          ]
        }
      </Styled.DisclaimerListItem>

      {stickableSKUs.includes(product.sku) && (
        <Styled.DisclaimerListItem>
          {
            i18n[
              'Indication for use: Invisalign Stickables are intended to be used in accordance with the Instructions For Use as decorative accessories only with Invisalign® clear aligners that are made from Invisalign® SmartTrack material.'
            ]
          }
        </Styled.DisclaimerListItem>
      )}
      {['AU', 'SG', 'MY', 'HK', 'MO'].includes(countryCode) && (
        <>
          <Styled.DisclaimerListItem>
            {
              i18n[
                'Estimated delivery duration to clinics: approximately 3 to 5 working days.'
              ]
            }
          </Styled.DisclaimerListItem>
          <Styled.DisclaimerListItem>
            {i18n['No cancellation is allowed upon order confirmation.']}
          </Styled.DisclaimerListItem>
          <Styled.DisclaimerListItem>
            {i18n['Stocks are subjected to availability.']}
          </Styled.DisclaimerListItem>
        </>
      )}
      {['NZ'].includes?.(countryCode) && (
        <>
          <Styled.DisclaimerListItem>
            {
              i18n[
                'Estimated delivery duration to clinics: approximately 6 working days.'
              ]
            }
          </Styled.DisclaimerListItem>
          <Styled.DisclaimerListItem>
            {i18n['No cancellation is allowed upon order confirmation.']}
          </Styled.DisclaimerListItem>
          <Styled.DisclaimerListItem>
            {i18n['Stocks are subjected to availability.']}
          </Styled.DisclaimerListItem>
        </>
      )}
      {['HK', 'MO'].includes(countryCode) && (
        <Styled.DisclaimerListItem>
          {i18n['Expiry date: 6 months and/or later (if have)']}
        </Styled.DisclaimerListItem>
      )}
    </ul>
  );
};
